import { fromEvent, from, of, EMPTY } from 'rxjs';
import * as Rx from 'rxjs'
import { filter, map, mergeMap, scan, merge, withLatestFrom, groupBy, pairwise,
  startWith, tap, delay, combineLatest, switchMap, distinctUntilChanged, take, share, debounceTime } from 'rxjs/operators';
import _ from 'lodash'
// import { gql } from 'apollo-boost';
import { Dispatch } from 'architecture'

import { gql } from 'apollo-boost';
import client from '../apollo';

const GET_STATES = gql`
query stateTags($states: [String!]!) {
  stateTags(states: $states) {
    id
    object {
      id
      tags
      {
        id
      }
    }
  }
}
`;

Dispatch.getState('states')
.pipe(
  switchMap(states => from(client
    .watchQuery({ 
      query: GET_STATES, 
      variables: { states: Object.keys(states) } 
    }
    ))
    .pipe(
      map(f => f.data.stateTags),
      combineLatest(Dispatch.getState('Tags')),
      map(([data, tags]) => 
        data.reduce((acc,state) => 
          ({ ...acc, [state.id]: state.object.tags.map(stateTag => 
            _.find(tags, tag => tag.id === stateTag.id)) })), {}),
      //map(([stateTag, tags]) => )
      //map(f => f.data.instances.reduce((acc, next) => ({...acc, [next.id]: next}), {})),
     // map(tags => ({...tags}))
      //map(tags => Object.keys(tags).)
      //map(f => f.map(tag => ({id: supplier.id, name: supplier.location.name})))
    )
  )
)
.subscribe(e => Dispatch.nextState('StateTags', e))